import React, { Fragment, useContext, useState } from "react";
import DateView from "../Record/DateView";
import { useNavigate } from "react-router-dom";
import {
  API_RESP_STATUS,
  PERCENTAGE_SYMBOL,
  RUPEE_SYMBOL,
} from "../../Constant/constant";
import { getBudgetAnalysis, deleteBudget } from "../Apis/apis";
import ProgressBar from "@ramonak/react-progress-bar";
import AddDailog from "../Record/AddDailog";
import AllStateContext from "../../context/allstateContext";
import AccountDialog from "../Record/AccountDialog";
import DateDialog from "../../Common/DateDialog";
import TimeDialog from "../../Common/TimeDialog";
import { useQuery } from "react-query";
import { formatDateMonthYear } from "../../Common/Common";
import AddNewAccountDialog from "../../Common/AddNewBudgetDialog";
import CategoryTransactionsDialog from "../../Common/CategoryTransactionsDialog";
import DeletedConfirmationDialog from "../../Common/DeletedConfirmationDialog";

const Budgets = () => {
  const history = useNavigate();
  const {
    openAccount,
    openDateDialog,
    openTimeDialog,
    startEndDate,
    addNewBudgetDialog,
    setAddNewBudgetDialog,
    selectedBudgetItem,
    setSelectedBudgetItem,
    setSearchDetail,
  } = useContext(AllStateContext);
  const [selectedOption, setSelectedOption] = useState("expense");
  const [showCategoryTx, setShowCategoryTx] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");

  const handleSelectionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const { data, error, isLoading, refetch } = useQuery(
    ["budgetListApiCall", startEndDate, selectedOption],
    async () => {
      const response = await getBudgetAnalysis(
        { type: selectedOption === "expense" ? 1 : 2 },
        formatDateMonthYear(startEndDate.startDate),
        "", // startEndDate.endDate,
        true
      );
      return response.data;
    }
  );

  const [deleteItemId, setDeleteItemId] = useState(null);
  const {
    openDeleteConfirmationDialog,
    setOpenDeleteConfirmationDialog,
  } = useContext(AllStateContext);

  const handleClick = (item, event) => {
    if (event === "edit") {
      setSelectedBudgetItem(item);
      setAddNewBudgetDialog(true);
    } else if (event === "delete") {
      setDeleteItemId(item.budgetDetail?.budgetId);
      setOpenDeleteConfirmationDialog(true);
    }
  };

  const handleDeleteConfirm = async () => {
    if (!deleteItemId) return;
    try {
      await deleteBudget(deleteItemId);
      refetch();
    } catch (err) {
      console.error("Delete budget failed:", err);
    }
    setDeleteItemId(null);
  };

  if (error) {
    if (error.response.status == API_RESP_STATUS.unauthorized) {
      localStorage.removeItem("token");
      history("/login");
    }
  }

  const handleSetBudget = (item) => {
    setSelectedBudgetItem(item);
    setAddNewBudgetDialog(true);
  };

  return (
    <div className="container" style={{ paddingBottom: "40px" }}>
      <div>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <DateView
              totalExpense={data?.payload?.totalInEx?.totalExpense}
              totalIncome={data?.payload?.totalInEx?.totalIncome}
            />
            <AddDailog fetchData={refetch} />
            {openAccount && <AccountDialog />}
            {openDateDialog && <DateDialog />}
            {openTimeDialog && <TimeDialog />}
            {addNewBudgetDialog && <AddNewAccountDialog refetch={refetch} />}
            {openDeleteConfirmationDialog && (
              <DeletedConfirmationDialog isDeleted={handleDeleteConfirm} />
            )}
            <CategoryTransactionsDialog
              open={showCategoryTx}
              onClose={() => {
                setShowCategoryTx(false);
                setSelectedCategoryName("");
              }}
              categoryName={selectedCategoryName}
              startDate={formatDateMonthYear(startEndDate.startDate)}
            />

            <div className="glass-card mb-4" style={{ padding: "24px" }}>
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h5 style={{ fontWeight: "700", margin: "0", letterSpacing: "0.02em" }}>
                  Budget Limits & Status
                </h5>
                <select
                  value={selectedOption}
                  onChange={handleSelectionChange}
                  className="form-select"
                  style={{
                    width: "150px",
                    fontSize: "0.9rem",
                    padding: "8px 12px !important",
                    height: "38px"
                  }}
                >
                  <option value="expense">Expense</option>
                  <option value="income">Income</option>
                </select>
              </div>

              {/* Set Budgets Section */}
              <div style={{ marginBottom: "32px" }}>
                <h6 style={{ fontWeight: "600", color: "var(--text-secondary)", marginBottom: "16px", textTransform: "uppercase", fontSize: "0.85rem", letterSpacing: "0.05em" }}>
                  Active Budgets
                </h6>
                <div className="list-group" style={{ margin: "0", border: "1px solid var(--border-color)" }}>
                  {data && data?.payload?.data?.filter((item) => item.budgetDetail).length > 0 ? (
                    data?.payload?.data
                      ?.filter((item) => item.budgetDetail)
                      .map((item) => {
                        const percent = ((item.spent * 100) / item.budgetDetail.limit) || 0;
                        const isOverBudget = percent >= 100;
                        return (
                          <div 
                            className="list-group-item d-flex align-items-center justify-content-between" 
                            key={item?.categoryId}
                          style={{
                              padding: "20px !important",
                              borderBottom: "1px solid var(--border-color)",
                              cursor: "pointer",
                              background: isOverBudget ? "rgba(220,38,38,0.04)" : "transparent",
                              borderLeft: isOverBudget ? "3px solid var(--danger)" : "3px solid transparent",
                              transition: "all 0.2s ease"
                            }}
                          >
                            <div 
                              className="d-flex align-items-center gap-3 w-100"
                              onClick={() => {
                                setSelectedCategoryName(item.name);
                                setShowCategoryTx(true);
                              }}
                            >
                              <div 
                                style={{
                                  width: "48px",
                                  height: "48px",
                                  borderRadius: "12px",
                                  background: isOverBudget ? "rgba(220,38,38,0.1)" : "var(--bg-surface-hover)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: isOverBudget ? "1px solid rgba(220,38,38,0.35)" : "1px solid var(--border-color)",
                                  boxShadow: isOverBudget ? "0 0 10px rgba(220,38,38,0.25)" : "none"
                                }}
                              >
                                <img
                                  style={{ height: "30px", width: "30px" }}
                                  src={item?.iconDetail?.icon}
                                  alt={item?.name}
                                />
                              </div>
                              <div style={{ flex: "1" }}>
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <div className="d-flex align-items-center gap-2">
                                    <span style={{ fontWeight: "700", fontSize: "1rem" }}>{item.name}</span>
                                    <span className="badge-balance" style={{ fontSize: "0.75rem", padding: "2px 6px" }}>
                                      {item.budgetDetail.month}
                                    </span>
                                    {isOverBudget && (
                                      <span style={{
                                        fontSize: "0.7rem", fontWeight: "800", padding: "2px 8px",
                                        borderRadius: "20px", background: "var(--danger)", color: "#fff",
                                        letterSpacing: "0.02em", animation: "budget-flash 1.4s ease-in-out infinite",
                                        display: "inline-flex", alignItems: "center", gap: "3px"
                                      }}>
                                        🚨 Over Budget!
                                      </span>
                                    )}
                                    {!isOverBudget && percent >= 85 && (
                                      <span style={{
                                        fontSize: "0.7rem", fontWeight: "700", padding: "2px 8px",
                                        borderRadius: "20px", background: "rgba(245,158,11,0.15)", color: "#f59e0b",
                                        border: "1px solid rgba(245,158,11,0.3)", letterSpacing: "0.02em"
                                      }}>
                                        ⚠ Near limit
                                      </span>
                                    )}
                                  </div>
                                  <div className="d-flex align-items-center gap-2">
                                    <button
                                      onClick={() => handleClick(item, "edit")}
                                      className="btn btn-secondary"
                                      style={{ width: "30px", height: "30px", padding: "0", minWidth: "30px", borderRadius: "8px" }}
                                    >
                                      <img style={{ width: "12px", height: "12px", filter: "invert(1)" }} src={require("../../Common/Icon/edit.png")} alt="edit" />
                                    </button>
                                    <button
                                      onClick={() => handleClick(item, "delete")}
                                      className="btn btn-secondary"
                                      style={{ width: "30px", height: "30px", padding: "0", minWidth: "30px", borderRadius: "8px", background: "var(--bg-surface-hover)", borderColor: "var(--border-color)" }}
                                    >
                                      <img style={{ width: "12px", height: "12px", filter: "invert(1)" }} src={require("../../Common/Icon/delete_icon.png")} alt="delete" />
                                    </button>
                                  </div>
                                </div>
                                
                                <div className="row g-2 mb-2" style={{ fontSize: "0.85rem", color: "var(--text-secondary)" }}>
                                  <div className="col-4">
                                    Limit: <span style={{ color: "var(--text-primary)", fontWeight: "600" }}>{RUPEE_SYMBOL}{item.budgetDetail.limit.toLocaleString("en-IN")}</span>
                                  </div>
                                  <div className="col-4">
                                    Spent: <span style={{ color: isOverBudget ? "var(--danger)" : "var(--text-primary)", fontWeight: "600" }}>{RUPEE_SYMBOL}{(item.spent || 0).toLocaleString("en-IN")}</span>
                                  </div>
                                  <div className="col-4 text-end">
                                    Remaining: <span style={{ color: isOverBudget ? "var(--text-muted)" : "var(--success)", fontWeight: "600" }}>
                                      {RUPEE_SYMBOL}{(item.budgetDetail.limit - item.spent > 0 ? (item.budgetDetail.limit - item.spent) : 0).toLocaleString("en-IN")}
                                    </span>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center gap-3">
                                  <div style={{ flex: "1" }}>
                                    <ProgressBar
                                      completed={percent > 100 ? 100 : parseFloat(percent.toFixed(1))}
                                      maxCompleted={100}
                                      width="100%"
                                      bgColor={isOverBudget ? "var(--danger)" : "var(--primary)"}
                                      baseBgColor="var(--border-color)"
                                      height="8px"
                                      customLabel={" "}
                                    />
                                  </div>
                                  <span style={{ fontSize: "0.82rem", fontWeight: "700", color: isOverBudget ? "var(--danger)" : "var(--success)", minWidth: "45px", textAlign: "right" }}>
                                    {percent.toFixed(1)}{PERCENTAGE_SYMBOL}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <div className="text-center py-4 text-muted" style={{ fontSize: "0.9rem" }}>
                      No budgets set yet.
                    </div>
                  )}
                </div>
              </div>

              {/* Unbudgets Section */}
              <div>
                <h6 style={{ fontWeight: "600", color: "var(--text-secondary)", marginBottom: "16px", textTransform: "uppercase", fontSize: "0.85rem", letterSpacing: "0.05em" }}>
                  Categories Without Budget
                </h6>
                <div className="list-group" style={{ margin: "0", border: "1px solid var(--border-color)" }}>
                  {data && data?.payload?.data?.filter((item) => !item.budgetDetail).length > 0 ? (
                    data?.payload?.data
                      ?.filter((item) => !item.budgetDetail)
                      .map((item) => (
                        <div 
                          className="list-group-item d-flex align-items-center justify-content-between" 
                          key={item?.categoryId}
                          style={{
                            padding: "16px 20px !important",
                            borderBottom: "1px solid var(--border-color)",
                            cursor: "pointer"
                          }}
                        >
                          <div 
                            className="d-flex align-items-center gap-3"
                            style={{ flex: 1 }}
                            onClick={() => {
                              setSelectedCategoryName(item.name);
                              setShowCategoryTx(true);
                            }}
                          >
                            <div 
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                background: "var(--bg-surface-hover)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid var(--border-color)"
                              }}
                            >
                              <img
                                style={{ height: "24px", width: "24px" }}
                                src={item?.iconDetail?.icon}
                                alt={item?.name}
                              />
                            </div>
                            <span style={{ fontWeight: "600", fontSize: "0.95rem" }}>{item.name}</span>
                          </div>

                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            style={{ padding: "6px 16px", fontSize: "0.82rem", fontWeight: "600" }}
                            onClick={() => handleSetBudget(item)}
                          >
                            SET BUDGET
                          </button>
                        </div>
                      ))
                  ) : (
                    <div className="text-center py-4 text-muted" style={{ fontSize: "0.9rem" }}>
                      All categories have budgets.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Budgets;
